<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
    // @ is an alias to /src

    import {mapState} from "vuex";

    export default {
        name: 'App',
        components: {},
        computed: {
        },
        watch: {
        },
        data() {
            return {}
        },
        mounted() {

        },
        beforeDestroy() {
        },
        methods: {},
    }
</script>

<style lang="scss">
  @import "src/assets/colors.scss";

  html {
    margin: 0;
    background: rgba($primary, 0.4);
  }

  body {
    margin: 0;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;

    min-height: 100vh;
    //noinspection CssInvalidPropertyValue
    min-height: -webkit-fill-available;

    display: flex;

    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  button {
    cursor: pointer;

    &:hover:not(:disabled) {
      filter: invert(0.5);
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.2;
    }
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>
